import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
background: linear-gradient(
    rgba(101, 75, 58, 0.07),
  rgba(101, 75, 58, 0.52)
);
    z-index: 1;
  }
`;

export const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  object-fit: cover;
   /* filter: grayscale(100%); */
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
  color: #C9C5B9;

  padding-top: 20rem;

  h1 {
    font-size: clamp(45px, 6vw, 72px);
    font-weight: 300;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
  }

  p {
    max-width: 640px;
    font-size: 16px;
    line-height: 1.6;
    opacity: 0.9;
    margin-bottom: 40px;
  }

  button {
    background: transparent;
    color: #C9C5B9;

    border: 1px solid #C9C5B9;
    padding: 14px 42px;

    font-size: 13px;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    cursor: pointer;

    transition: all 0.35s ease;

    &:hover {
      background: #ffffff;
      border-color: #ffffff;
      color: #4c3729;
    }
  }
`;

export const Brand = styled.div`
 position: absolute;
  font-family: "Bodoni Moda", serif;
  width: 100%;
  left: 0;
  top: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #654B3A;
  letter-spacing: 2px;

  h1 {
    font-weight: 700;
  }

  small {
    font-size: 20px;
    color: #654B3A;
    margin: 0 6px;
  }
`;

export const About = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 100px 20px 60px 20px;

  .content {
    max-width: 1000px;
    text-align: center;
    color: #4c3729;
    font-family: 'Playfair Display', serif;

    h2 {
      font-size: clamp(32px, 3vw, 48px);
      font-weight: 700;
      margin-bottom: 16px;
      color: #4c3729;
      letter-spacing: 1px;
    }

    .highlight {
      font-size: clamp(18px, 1.2vw, 22px);
      font-weight: 500;
      color: #7a5c48;
      margin-bottom: 16px;
      display: block;
    }

    .story {
      font-size: clamp(16px, 1vw, 18px);
      line-height: 1.8;
      color: #4c3729;
      margin-bottom: 24px;

      p + p {
        margin-top: -8px;
      }

      strong {
        font-weight: 700;
        color: #4c3729;
      }

      .make {
        margin-top: 50px;
        padding: 0;
        line-height: 1.2;
      }
    }

    .signature {
      font-style: italic;
      font-weight: 500;
      font-size: clamp(16px, 1vw, 18px);
      color: #4c3729;
    }
  }

  @media (max-width: 768px) {
    .content {
      padding: 0 20px;

      h2 {
        font-size: clamp(28px, 5vw, 36px);
      }

      .highlight, .story, .signature {
        font-size: clamp(14px, 3vw, 16px);
      }
    }
  }
`;

export const Card = styled.div`
  cursor: pointer;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;

    transition: 0.4s ease;
  }
`;

export const CardImage = styled.div`
  width: 100%;
  height: 400px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: 0.4s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

export const CardInfo = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  span {
    font-size: 14px;
    color: #4c3729;
  }

  .price-original {
    text-decoration: line-through;
    color: #999;
    font-size: 12px;
  }

  .price-launch {
    font-weight: bold;
    font-size: 16px;
    color: #4c3729;
  }

  .div-size {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .size {
      background-color: #e8e8e8;
      padding: 0.3rem 0.5rem;
      border-radius: 4px;
    }
  }

button {
  position: relative;
  width: fit-content;
  margin-top: auto;
  color: #4c3729;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 0.6rem 1rem; 
  border-bottom: solid 1px #4c3729;
  overflow: hidden;
  background: transparent;
  z-index: 0;
  transition: color 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #4c3729;
    z-index: -1;
    transform: scaleY(0);
    transform-origin: bottom;
    transition: transform 0.3s ease;
  }

  &:hover {
    color: #fff;
  }

  &:hover::after {
    transform: scaleY(1);
  }
}
`;

export const CarouselSection = styled.section`
  position: relative;
  width: 100%;
  padding: 40px 0;
  overflow: visible;

  .swiper {
    padding-bottom: 50px;
  }

  .swiper-pagination {
    bottom: 0;
    display: flex;
    justify-content: center;
    gap: 8px;
    position: absolute;
    width: 100%;
  }

  .swiper-pagination {
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    opacity: 1;
    background: #C9C5B9;
  }

  .swiper-pagination-bullet-active {
    background: #4c3729;
    transform: scale(1.2);
  }
`;

export const FullScreen = styled.div`
  width: 100%;
  margin: 40px 0;
  position: relative;

  .description {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 900px;
    width: 90%;
    text-align: center;
    color: white;
    z-index: 2;

    h1 {
      font-size: clamp(36px, 4vw, 60px);
      font-weight: 300;
      letter-spacing: -0.02em;
      margin-bottom: 20px;
    }

    p {
      font-size: clamp(16px, 1.8vw, 20px);
      line-height: 1.6;
      opacity: 0.9;
      margin-bottom: 0;
    }
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      rgba(101, 75, 58, 0.07),
      rgba(101, 75, 58, 0.52)
    );
    z-index: 1; /* abaixo da description, acima da imagem */
  }

  img {
    width: 100%;
    height: 750px;
    display: block;
    object-fit: cover;
    object-position: top;
    border-radius: 6px;
  }
`;

export const Media = styled.section`
  width: 100%;
  padding: 80px 20px 120px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h2 {
    font-size: clamp(32px, 4vw, 48px);
    color: #4c3729;
    font-weight: 400;
    margin-bottom: 16px;
  }

  p {
    max-width: 700px;
    color: #654b3a;
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 40px;
  }

  .icons {
    display: flex;
    gap: 30px; /* reduzido de 40px para 30px */

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;  /* antes 60px */
      height: 50px; /* antes 60px */
      border-radius: 50%;
      background: #C9C5B9;
      color: #4c3729;
      font-size: 24px; /* antes 28px */
      transition: all 0.3s ease;

      &:hover {
        background: #4c3729;
        color: #fff;
        transform: scale(1.1);
      }
    }

    @media (max-width: 768px) {
      gap: 20px;
      a {
        width: 45px;   /* antes 50px */
        height: 45px;  /* antes 50px */
        font-size: 20px; /* antes 24px */
      }
    }
  }
`;

export const Footer = styled.footer`
  width: 100%;
  padding: 40px 20px;
  border-top: 1px solid #C9C5B9;
  background: #f8f4ef;
  text-align: center;
  color: #4c3729;
  font-size: 14px;
  line-height: 1.6;

  a {
    color: #4c3729;
    text-decoration: underline;
    margin-left: 4px;

    &:hover {
      color: #654b3a;
    }
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 30px 10px;
  }
`;